import React, { lazy, Suspense } from 'react';
var RichtextEditor = lazy(function () {
  return import('./Editor');
}); // render loading here

var renderLoader = function renderLoader() {
  return React.createElement("p", null, "Loading");
};
/**
 * @type {React.FC<import('./types').RichtextEditorProps> }
 */


var RichtextEditorLazy = React.forwardRef(function (props, ref) {
  return React.createElement(Suspense, {
    fallback: renderLoader()
  }, React.createElement(RichtextEditor, Object.assign({}, props, {
    ref: ref
  })));
});
export default RichtextEditorLazy;